import impression from './impression.js';

export default (cart) => ({
	event: 'crossPop',
	pageName: cart.page.tracking,
	cartLocale: cart.url.locale,
	ecommerce: {
		currencyCode: cart.order.currency,
		impressions: cart.order.impressions.map(impression)
	},
	orderId: cart.order.id,
	contentGroup: cart.order.contentGroup
});
